import React from "react";
import RoleAlignedContent from "../FunctionComponents/RoleAlignedFolder/RoleAlignedContent";

function RoleAligned() {
  return (
    <>
      <RoleAlignedContent />
    </>
  );
}

export default RoleAligned;
